import React, { useState, forwardRef } from 'react';
import { Input } from './ui/input';
import { Eye, EyeOff } from 'lucide-react';

/**
 * Password input with a toggle eye icon. Drop-in replacement for a plain <Input type="password" />.
 * Use the `leftIcon` prop to render a lucide icon on the left (matches the existing login/register layout).
 */
export const PasswordInput = forwardRef(function PasswordInput(
  { leftIcon: LeftIcon, className = '', iconColor = 'text-slate-400', ...props },
  ref
) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      {LeftIcon ? (
        <LeftIcon className={`absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 ${iconColor}`} />
      ) : null}
      <Input
        ref={ref}
        type={show ? 'text' : 'password'}
        className={`${LeftIcon ? 'pl-10' : ''} pr-11 ${className}`}
        {...props}
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        aria-label={show ? 'Ocultar senha' : 'Mostrar senha'}
        className="absolute right-2 top-1/2 -translate-y-1/2 h-9 w-9 flex items-center justify-center rounded-md text-slate-500 hover:text-slate-700 hover:bg-slate-100 dark:hover:bg-slate-800 focus:outline-none focus:ring-2 focus:ring-primary/40"
        data-testid={props['data-testid'] ? `${props['data-testid']}-toggle` : 'password-toggle'}
        tabIndex={-1}
      >
        {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
});

export default PasswordInput;
